import type { LiveAlertKind } from '@/types';

/** Minimal translate signature so this helper stays UI-library agnostic. */
type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface LiveAlertMeta {
  /** Toast tone used by the shared toast component. */
  tone: 'info' | 'success' | 'warning' | 'error';
  icon: string;
}

const META: Record<LiveAlertKind, LiveAlertMeta> = {
  assignment_needed: { tone: 'warning', icon: 'ri-user-follow-line' },
  driver_issue: { tone: 'error', icon: 'ri-error-warning-line' },
  delay: { tone: 'warning', icon: 'ri-time-line' },
  new_order: { tone: 'info', icon: 'ri-file-add-line' },
};

export function liveAlertMeta(kind: LiveAlertKind): LiveAlertMeta {
  return META[kind] ?? { tone: 'info', icon: 'ri-notification-3-line' };
}

export function liveAlertTitle(kind: LiveAlertKind, t: Translate): string {
  return t(`notifications.alert.${kind}.title`);
}

/** Body text; falls back to a generic line when no order is attached. */
export function liveAlertBody(kind: LiveAlertKind, orderId: string | null, t: Translate): string {
  return orderId
    ? t(`notifications.alert.${kind}.body`, { orderId })
    : t(`notifications.alert.${kind}.bodyGeneric`);
}